import type { CSSProperties } from 'react';
import type { ProjectConfig } from '../../api/types';
import { brandAssets, brandText } from '../../lib/brand';
import { UserMenu } from './UserMenu';

/**
 * The 60 px glass header: the pack's banner image behind, logo left, subtitle centred, project name right,
 * and the user button. At phone widths it becomes the thin 57 px bar (logo + name over a dark scrim).
 */
export function Header({ project }: { project: ProjectConfig }) {
  const { logoUrl, bannerUrl } = brandAssets(project.brand);
  const style = bannerUrl ? ({ '--mm-banner': `url("${bannerUrl}")` } as CSSProperties) : undefined;
  return (
    <header className="mm-header" style={style}>
      {logoUrl && <img className="mm-header-logo" src={logoUrl} alt="" />}
      {project.subtitle && <p className="mm-header-sub">{project.subtitle}</p>}
      <h1 className="mm-header-title">{brandText(project.brand, 'shortTitle') ?? project.title}</h1>
      <UserMenu />
    </header>
  );
}
